import { render, staticRenderFns } from "./ExtendTermTable.vue?vue&type=template&id=0a77b13c&"
import script from "./ExtendTermTable.vue?vue&type=script&lang=js&"
export * from "./ExtendTermTable.vue?vue&type=script&lang=js&"
import style0 from "./ExtendTermTable.vue?vue&type=style&index=0&id=0a77b13c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports